module.exports = __webpack_public_path__ + "static/img/choiceMessage.5b3ba302.png";